<div class="modal-header">
    <h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.addPageToCart}}</h3>
</div>
<div class="modal-body">
   <div class="row">
     <div class="col-xs-4"><h4>{{LOCALIZATION.numberSheets}}</h4></div>
     <div class="col-xs-4">
       <input class="form-control" [(ngModel)]="pages" type="number" min="1" />
     </div>
     <div class="col-xs-4">
       <button class="btn btn-primary me-2" (click)="addPages()">{{LOCALIZATION.addToCart}}</button>
       <button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
     </div>
   </div>
 </div>
